import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoashtavinayakcabservice() {



  const cardData =
  {
    keyword: 'Mumbai to Ashtavinayak Cab Service ',
    heading: 'Shambhu Cabs: Mumbai to Ashtavinayak Cab Service  ',
    headingDescription: 'Shambhu Cabs offers dedicated Mumbai to Ashtavinayak Cab Service, providing safe, comfortable, and hassle-free travel for devotees visiting all eight sacred Ganpati temples across Maharashtra. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth spiritual journey with well-maintained vehicles and experienced chauffeurs familiar with the complete Ashtavinayak route. We offer flexible 1-day, 2-day, and customized itineraries, along with doorstep pickup from South Mumbai to Thane, Borivali to Navi Mumbai. With 24/7 booking assistance, reliable navigation, and a commitment to punctuality, Shambhu Cabs makes your Mumbai to Ashtavinayak trip convenient, peaceful, and truly memorable. Whether you’re traveling with family, friends, or groups, Shambhu Cabs ensures a comfortable and devotional travel experience throughout your Ashtavinayak yatra.',

    top: 'Top Places to Visit in Ashtavinayak with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Mayureshwar Temple, Morgaon",
    "description": "Mayureshwar Temple in Morgaon is considered the first and most important shrine of the Ashtavinayak Yatra. Dedicated to Lord Ganesha in the form of Mayureshwar, the temple features a beautiful black-stone idol and sacred architecture. It is located along the banks of the Karha River and symbolizes wisdom and prosperity."
  },
  {
    "title": "Siddhivinayak Temple, Siddhatek",
    "description": "Located on the banks of the Bhima River, Siddhivinayak Temple is dedicated to Lord Ganesha as the giver of spiritual success (Siddhi). The temple is surrounded by scenic hills and is known for its peaceful ambiance. Devotees often walk the 1 km path around the temple as a ritual of devotion."
  },
  {
    "title": "Ballaleshwar Temple, Pali",
    "description": "Ballaleshwar Temple in Pali is the only temple among the Ashtavinayak where Lord Ganesha is worshipped by his devotee’s name—Ballal. The temple is known for its unique architecture, where the rising sun directly illuminates the idol during specific times of the year."
  },
  {
    "title": "Varadvinayak Temple, Mahad",
    "description": "Varadvinayak Temple in Mahad symbolizes Lord Ganesha as the giver of boons and blessings. The temple has a self-manifested (Swayambhu) idol and a sacred pond where devotees perform rituals. The serene surroundings make it a peaceful spiritual retreat."
  },
  {
    "title": "Chintamani Temple, Theur",
    "description": "The Chintamani Temple in Theur is dedicated to Lord Ganesha as the remover of worries and protector of devotees. Built by the Peshwas, the temple features classic Maratha architecture and a calm spiritual environment. It is one of the most-visited Ashtavinayak shrines due to its proximity to Pune."
  },
  {
    "title": "Girijatmaj Temple, Lenyadri",
    "description": "Girijatmaj Temple is the only Ashtavinayak shrine situated on a mountain and carved into a single rock cave. Located in the Lenyadri caves, the temple requires a climb of 300+ steps. The breathtaking hill views and unique cave structure make it a spiritually and visually captivating experience."
  },
  {
    "title": "Vighneshwar Temple, Ozar",
    "description": "Vighneshwar Temple in Ozar is dedicated to Lord Ganesha as the remover of obstacles. The temple is known for its golden dome, deepstambh (lamp tower), and riverfront location. It is believed that Lord Vighneshwar defeated the demon Vighnasur here, protecting devotees from obstacles."
  },
  {
    "title": "Mahaganpati Temple, Ranjangaon",
    "description": "Mahaganpati Temple in Ranjangaon is the final temple of the Ashtavinayak Yatra and is considered the most powerful form of Lord Ganesha. Legend says that Lord Shiva worshipped Mahaganpati before defeating Tripurasura. The temple’s magnificent architecture and peaceful aura attract thousands of devotees."
  }
],


"services": [
  {
    "name": "Ashtavinayak Darshan Cab Mumbai",
    "description": "Ashtavinayak Darshan Cab Mumbai offers a comfortable and reliable transportation service for pilgrims and tourists visiting all eight Ashtavinayak temples from Mumbai. The service includes professional drivers familiar with all temple routes, timely pickups and drop-offs, well-maintained vehicles, and flexible travel options. Passengers can enjoy a smooth and safe journey while exploring spiritual and cultural landmarks, making it perfect for devotees, families, and solo travelers."
  },
  {
    "name": "Mumbai Ashtavinayak Tour Taxi",
    "description": "Mumbai Ashtavinayak Tour Taxi provides a full-day or multi-day cab service dedicated to visiting the Ashtavinayak temples. Vehicles are equipped for comfort, with options including sedans and SUVs suitable for families or small groups. Professional drivers ensure smooth navigation across highways and rural routes, while passengers enjoy stress-free travel with convenient pickup and drop options, making the yatra both memorable and hassle-free."
  },
  {
    "name": "8 Ganpati Darshan Mumbai Cab",
    "description": "8 Ganpati Darshan Mumbai Cab is designed specifically for devotees planning to visit all eight Ganapati temples. This service ensures a well-organized travel itinerary, experienced drivers, and comfortable vehicles for long intercity journeys. Passengers can focus on their spiritual journey while the cab service handles route planning, navigation, and timing for an efficient and serene pilgrimage."
  },
  {
    "name": "Mumbai to Ashtavinayak Travel Cab",
    "description": "Mumbai to Ashtavinayak Travel Cab offers dependable intercity travel for pilgrims heading to Ashtavinayak temples. With professional drivers, clean and well-maintained cars, and flexible pickup and drop-off points, this service provides convenience and safety. Perfect for family trips, spiritual tours, and group travels, passengers can enjoy scenic routes and a comfortable ride throughout the journey."
  },
  {
    "name": "One-Day Ashtavinayak Cab Mumbai",
    "description": "One-Day Ashtavinayak Cab Mumbai is ideal for travelers planning a single-day temple visit. The service includes early morning pickups, optimized travel routes to cover multiple temples efficiently, and comfortable vehicles to accommodate passengers. With professional chauffeurs, flexible scheduling, and detailed planning, this service ensures a hassle-free and fulfilling Ashtavinayak pilgrimage experience."
  },
  {
    "name": "Mumbai Ashtavinayak Car Rental",
    "description": "Mumbai Ashtavinayak Car Rental provides flexible and affordable car hire options for devotees visiting the Ashtavinayak temples. Customers can choose between sedans, SUVs, and premium vehicles with experienced drivers, ensuring safety and comfort. Ideal for families, groups, or corporate travelers planning an organized pilgrimage, this service allows complete control over travel timing and route preferences."
  },
  {
    "name": "SUV Cab Ashtavinayak Trip",
    "description": "SUV Cab Ashtavinayak Trip caters to larger groups or families requiring spacious and comfortable vehicles for Ashtavinayak temple visits. Equipped with modern amenities and safety features, these SUVs ensure a smooth journey across highways and rural roads. Professional drivers guide the trip, allowing passengers to focus on the spiritual experience without worrying about travel logistics."
  },
  {
    "name": "Sedan Cab Mumbai Ashtavinayak",
    "description": "Sedan Cab Mumbai Ashtavinayak offers an economical and comfortable option for solo travelers or small families. Well-maintained sedans, professional chauffeurs, and flexible booking options make the journey safe and convenient. Passengers can enjoy scenic views along the way while relying on punctual and reliable service from Mumbai to all eight Ashtavinayak temples."
  },
  {
    "name": "Affordable Ashtavinayak Cab Mumbai",
    "description": "Affordable Ashtavinayak Cab Mumbai provides budget-friendly travel options without compromising on comfort or safety. This service is perfect for pilgrims, students, or groups looking for economical transportation to all eight Ashtavinayak temples. Vehicles are well-maintained, drivers are experienced, and the service ensures timely pickups and drops, making the spiritual journey stress-free and cost-effective."
  },
  {
    "name": "Ashtavinayak Yatra Cab from Mumbai",
    "description": "Ashtavinayak Yatra Cab from Mumbai offers complete yatra solutions for devotees visiting the Ashtavinayak temples. The service includes route planning, comfortable vehicles, professional drivers, and flexible schedules. Whether planning a single-day yatra or a multi-day spiritual trip, this cab service ensures passengers can focus on the pilgrimage while enjoying a safe and comfortable travel experience."
  },
  {
    "name": "Best Ashtavinayak Cab Service Mumbai",
    "description": "Best Ashtavinayak Cab Service Mumbai is known for its punctuality, reliable drivers, and well-maintained vehicles. Catering to families, solo travelers, and corporate groups, this service prioritizes passenger comfort and safety. With professional chauffeurs experienced in temple routes and highway travel, passengers can enjoy a smooth, stress-free, and memorable Ashtavinayak pilgrimage."
  },
  {
    "name": "24×7 Ashtavinayak Taxi Mumbai",
    "description": "24×7 Ashtavinayak Taxi Mumbai provides round-the-clock taxi services for devotees traveling from Mumbai. Whether early morning departures or late-night returns, this service ensures timely pickups, professional drivers, and safe journeys. Passengers benefit from flexible schedules, highway-optimized routes, and comfortable vehicles for a hassle-free pilgrimage experience."
  },
  {
    "name": "Ashtavinayak Darshan Package Cab Mumbai",
    "description": "Ashtavinayak Darshan Package Cab Mumbai offers customized travel packages for visiting all eight Ashtavinayak temples. The package includes route planning, comfortable vehicles, professional drivers, and flexible timing to ensure a stress-free pilgrimage. Perfect for families, groups, or solo travelers, this service provides a comprehensive and organized Ashtavinayak experience."
  },
  {
    "name": "Family Cab Ashtavinayak Mumbai",
    "description": "Family Cab Ashtavinayak Mumbai caters to family groups planning a pilgrimage to Ashtavinayak temples. Spacious SUVs or sedans, professional drivers, and a comfortable travel experience ensure a smooth and enjoyable journey. The service is designed to provide convenience, safety, and a relaxed travel environment for families of all sizes."
  },
  {
    "name": "Mumbai Ashtavinayak Round Trip Cab",
    "description": "Mumbai Ashtavinayak Round Trip Cab provides reliable round-trip transportation for devotees planning to return to Mumbai after their pilgrimage. Vehicles are well-maintained, drivers are experienced, and travel schedules are optimized for comfort and efficiency. Passengers can enjoy a seamless journey with convenient pickups and drops at multiple locations if needed."
  },
  {
    "name": "Corporate Ashtavinayak Cab",
    "description": "Corporate Ashtavinayak Cab offers specialized services for corporate groups or office teams visiting the Ashtavinayak temples. Professional drivers, comfortable vehicles, and well-planned routes ensure a smooth and efficient journey. The service caters to group travel needs with punctuality, safety, and luxury, making it ideal for corporate retreats or team outings."
  },
  {
    "name": "Safe Ashtavinayak Cab Mumbai",
    "description": "Safe Ashtavinayak Cab Mumbai emphasizes passenger safety during travel from Mumbai to Ashtavinayak temples. Well-maintained vehicles, trained drivers, and adherence to traffic and safety regulations ensure a secure and comfortable journey. Ideal for families, solo travelers, and groups, this service provides peace of mind throughout the pilgrimage."
  }
],

"tableData": [
  ["Ashtavinayak Darshan Cab Mumbai", "Mumbai Ashtavinayak Tour Taxi"],
  ["8 Ganpati Darshan Mumbai Cab", "Mumbai to Ashtavinayak Travel Cab"],
  ["One-Day Ashtavinayak Cab Mumbai", "Mumbai Ashtavinayak Car Rental"],
  ["SUV Cab Ashtavinayak Trip", "Sedan Cab Mumbai Ashtavinayak"],
  ["Affordable Ashtavinayak Cab Mumbai", "Ashtavinayak Yatra Cab from Mumbai"],
  ["Best Ashtavinayak Cab Service Mumbai", "24×7 Ashtavinayak Taxi Mumbai"],
  ["Ashtavinayak Darshan Package Cab Mumbai", "Family Cab Ashtavinayak Mumbai"],
  ["Mumbai Ashtavinayak Round Trip Cab", "Corporate Ashtavinayak Cab"],
  ["Safe Ashtavinayak Cab Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Ashtavinayak Cab Service with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai to Ashtavinayak cab services, perfect for pilgrimage tours, family trips, and comfortable long-distance travel across the Ashtavinayak temples."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a smooth and relaxing journey to all Ashtavinayak temples."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pilgrimage Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Mumbai to Ashtavinayak routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Ashtavinayak cab service completely stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, travel queries, and route guidance for your pilgrimage."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Pilgrimage Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans designed to fit your Mumbai to Ashtavinayak travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip, ensuring a hygienic and safe travel experience for your pilgrimage."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Ashtavinayak journey smooth, comfortable, and worry-free."
  }
]




















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Ashtavinayak cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Ashtavinayak cab services for devotees and travelers.',
  },
  {
    question: 'How can I book a Mumbai to Ashtavinayak cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Ashtavinayak cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for traveling to all Ashtavinayak temples from Mumbai.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Ashtavinayak route?',
    answer: 'Yes, our drivers are licensed, professional, and experienced in covering the entire Ashtavinayak circuit safely and comfortably.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Ashtavinayak trip?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off locations at any of the Ashtavinayak temples.',
  },
  {
    question: 'Is the Mumbai to Ashtavinayak cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Ashtavinayak cab services to suit your pilgrimage schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Ashtavinayak cab bookings?',
    answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Ashtavinayak cab bookings?',
    answer: 'We accept payments via UPI, digital wallets, credit/debit cards, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the Mumbai to Ashtavinayak journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Mumbai to Ashtavinayak travel for any assistance.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Patil',
    feedback: 'Our Mumbai to Ashtavinayak pilgrimage with Shambhu Cabs was smooth, comfortable, and well-organized. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Joshi',
    feedback: 'Very reliable Mumbai to Ashtavinayak cab service. The driver was professional, and the trip was hassle-free.',
    rating: 5,
  },
];











































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ashtavinayak Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-ashtavinayak-cab.jpg",
  "description": "Shambhu Cabs provides reliable Mumbai to Ashtavinayak cab services for comfortable and safe travel. Ideal for Ashtavinayak Darshan, family trips, corporate travel, and one-day tours. Choose from sedan, SUV, and premium cars for round-trip or one-way travel with professional drivers and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-ashtavinayak-cab-service"
  }
};





  return (
    <div>

<Helmet>
  <title>Mumbai to Ashtavinayak Cab Service | Ashtavinayak Darshan Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Ashtavinayak cab with Shambhu Cabs. Safe, affordable, and comfortable travel for Ashtavinayak Darshan, family trips, corporate travel, and one-day tours. Choose sedan, SUV, or premium cars with professional drivers."
  />

  <meta
    name="keywords"
    content="Ashtavinayak Darshan Cab Mumbai, Mumbai Ashtavinayak Tour Taxi, 8 Ganpati Darshan Mumbai Cab, Mumbai to Ashtavinayak Travel Cab, One-Day Ashtavinayak Cab Mumbai, Mumbai Ashtavinayak Car Rental, SUV Cab Ashtavinayak Trip, Sedan Cab Mumbai Ashtavinayak, Affordable Ashtavinayak Cab Mumbai, Ashtavinayak Yatra Cab from Mumbai, Best Ashtavinayak Cab Service Mumbai, 24×7 Ashtavinayak Taxi Mumbai, Ashtavinayak Darshan Package Cab Mumbai, Family Cab Ashtavinayak Mumbai, Mumbai Ashtavinayak Round Trip Cab, Corporate Ashtavinayak Cab, Safe Ashtavinayak Cab Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoashtavinayakcabservice;